import { TFunction } from 'next-i18next'

export type UnitType = 'condo' | 'house' | 'townhouse'
export type UnitScope = 'entire' | 'partial' | 'single'

export interface ListingTypeConfig {
  entire: string
  partial: string
  single: string
}

export interface ListingTypesMap {
  condo: ListingTypeConfig
  house: ListingTypeConfig
  townhouse: ListingTypeConfig
}

export interface GetListingTypeTextParams {
  unitType: string
  unitScope: string
}

export const createListingTypesMap = (t: TFunction): ListingTypesMap => ({
  condo: {
    entire: t('b.listing.view.entire_apartment.text', 'Entire Apartment'),
    partial: t('b.listing.view.partial_apartment.text', 'Partial Apartment'),
    single: t('b.listing.view.room_in_apartment.text', 'Room in Apartment')
  },
  house: {
    entire: t('b.listing.view.entire_house.text', 'Entire House'),
    partial: t('b.listing.view.partial_house.text', 'Partial House'),
    single: t('b.listing.view.room_in_house.text', 'Room in House')
  },
  townhouse: {
    entire: t('b.listing.view.entire_townhouse.text', 'Entire Townhouse'),
    partial: t('b.listing.view.partial_townhouse.text', 'Partial Townhouse'),
    single: t('b.listing.view.room_in_townhouse.text', 'Room in Townhouse')
  }
})

export const getListingTypeText = (
  { unitType, unitScope }: GetListingTypeTextParams,
  t: TFunction
): string => {
  if (!unitType || !unitScope) {
    return ''
  }

  const listingTypes = createListingTypesMap(t)

  const normalizedUnitType = unitType.toLowerCase() as UnitType
  const normalizedUnitScope = unitScope.toLowerCase() as UnitScope

  const typeConfig = listingTypes[normalizedUnitType]
  if (!typeConfig) {
    return t('common.unknown', 'Unknown')
  }

  const scopeText = typeConfig[normalizedUnitScope]
  return scopeText || t('common.unknown', 'Unknown')
}
